"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initMergeSliceReducer = initMergeSliceReducer;
exports.mergeSliceReducer = mergeSliceReducer;

var _storeHelper = require("../store-helper");

var _deprecated = require("../deprecated.util");

function initMergeSliceReducer(reduxStore, rootReducerCreator) {
  (0, _deprecated.deprecated)('initMergeSliceReducer() is deprecated, use storeHelper.init()');

  _storeHelper.storeHelper.init(reduxStore, rootReducerCreator);
}

function mergeSliceReducer(reducer) {
  (0, _deprecated.deprecated)('mergeSliceReducer() is deprecated, use storeHelper.mergeTopReducer()');

  _storeHelper.storeHelper.mergeTopReducer(reducer);

  return reducer;
}